
    import I18n from 'i18nObj';
    
      import 'translations/moderated_grading';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('moderated_grading');
  